"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginBase_1 = require("../PluginBase");
const IContainerInjection_1 = require("../../Container/IContainerInjection");
const Mixin_1 = require("../../Util/Mixin");
const DataAttributes_1 = require("../../Enum/DataAttributes");
/**
 * Widget step plugin base implementation.
 */
class WidgetStepPlugin extends PluginBase_1.default {
    /**
     * Constructs the step plugin.
     *
     * @param {WidgetStepPluginDefinition} definition
     * @param {WidgetConfig} widgetConfig
     * @param {WidgetState} state
     * @param {EventContainerContext} eventContext
     * @param {RactiveWrapper} ractiveWrapper
     */
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper) {
        super(definition);
        /**
         * The actual renderer object created after rendering.
         */
        this.renderer = null;
        this.widgetConfig = widgetConfig;
        this.state = state;
        this.eventContext = eventContext;
        this.ractiveWrapper = ractiveWrapper;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"));
    }
    /**
     * Determines whether the step should be set / applied.
     *
     * If false returned this step will be skipped.
     *
     * @return {Promise<boolean>}
     */
    shouldApply() {
        return Promise.resolve(true);
    }
    /**
     * Initializes the step.
     *
     * @return {Promise<*>}
     */
    initialize() {
        return Promise.resolve();
    }
    /**
     * Creates the renderer handler.
     */
    render() {
        this.renderer = this.ractiveWrapper.createRenderer(this.getTemplate(), this.widgetConfig, this.state);
        return Promise.resolve();
    }
    /**
     * Register handlers for the template.
     */
    registerHandlers() {
        // Noop.
    }
    /**
     * Disable the controls of the step.
     */
    disable() {
        return Promise.resolve().then(() => {
            this.eventContext.destroy();
            const container = document.getElementById(this.widgetConfig.getContainerId());
            // Disables all form elements.
            const formElements = container.querySelectorAll("button, input, textarea, datalist, output, select");
            for (let i = 0, element; element = formElements[i++];) {
                element.setAttribute("disabled", "");
                element.setAttribute(DataAttributes_1.DataAttributes.INPUT_DISABLED, "");
            }
            // Disable form submissions.
            const forms = container.querySelectorAll("form");
            for (let i = 0, element; element = forms[i++];) {
                element.addEventListener("keypress", (event) => event.keyCode != 13);
            }
        });
    }
    /**
     * Remove the step.
     */
    destroy() {
        if (this.renderer) {
            this.renderer.teardown();
        }
        const element = document.getElementById(this.widgetConfig.getContainerId());
        if (element) {
            element.innerHTML = "";
        }
        this.eventContext.destroy();
        return Promise.resolve();
    }
}
exports.default = WidgetStepPlugin;
Mixin_1.default(WidgetStepPlugin, IContainerInjection_1.default);
